module.exports = __webpack_public_path__ + "static/banner-e2f5a095f8cafe8b4ed7a1d630276aee.jpg";